export default __webpack_public_path__ + "static/media/badge-background.c514a7fa.svg";